<template>
  <div>
    <image-message
      :image-path="notFound ? notFoundSvg : searchSvg"
      :image-alt="$t('lists.common.messages.searchImageForNoResults')">
      <slot v-if="$slots.default"></slot>
      <template v-else>
        <m-text variant="md-bold">{{ translatedTitle }}</m-text>
        <m-text variant="body-sm">{{ translatedSubtitle }}</m-text>
      </template>
      <div :class="hasFooterSlot ? 'm-t-2 p-b-4' : ''">
        <slot name="footer" />
      </div>
    </image-message>
  </div>
</template>

<script>
import { ImageMessage } from '@/components';
import search from '@satellite/assets/search.svg';
import notfound from '@satellite/assets/appointment404.svg';

/**
 * Used when there are no records returned from API
 * @displayName No Results
 */
export default {
  name: 'NoResults',
  components: { ImageMessage },
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    notFound: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    translatedTitle() {
      return this.title ?? this.$t('lists.common.messages.weCouldntFindResultsForYourSearch');
    },
    translatedSubtitle() {
      return (
        this.subtitle ??
        this.$t('lists.common.messages.pleaseChangeTheTermsOfYourSearchAndTryAgain')
      );
    },
    hasFooterSlot() {
      return Boolean(this.$slots['footer']);
    }
  },
  data() {
    return {
      searchSvg: search,
      notFoundSvg: notfound
    };
  }
};
</script>
